import { render, staticRenderFns } from "./franchise-university.vue?vue&type=template&id=29f384af&scoped=true&"
import script from "./franchise-university.vue?vue&type=script&lang=js&"
export * from "./franchise-university.vue?vue&type=script&lang=js&"
import style0 from "./franchise-university.vue?vue&type=style&index=0&id=29f384af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f384af",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
